import { PicklistCard } from "components/Picklist/common/PicklistCard";
import { LaptopMac } from "@mui/icons-material";
import { DataList, DataListItem } from "components/Picklist/common/DataList";
import React from "react";
import { useIsLocal } from "hooks/useIsLocalhost";
import { OrderItem } from "hooks/useFulfillmentBatch";
import { WarehouseLocationLink } from "components/Locations/WarehouseLocationLink";

export function PicklistInventoryCard({
  condensed = false,
  inventory,
  title = "Inventory to Pick",
  children,
}: {
  inventory: OrderItem;
  condensed?: boolean;
  title?: string;
  children?: React.ReactNode;
}) {
  const isLocal = useIsLocal();
  return (
    <PicklistCard title={title} Icon={LaptopMac}>
      <DataList>
        <DataListItem label="Label ID" value={inventory?.label} />
        {isLocal && <DataListItem label="(devonly) Inventory ID" value={inventory?.id} />}
        {inventory?.deviceType && <DataListItem label="Device Type" value={inventory.deviceType} />}
        {!condensed && (
          <>
            {inventory?.year && <DataListItem label="Year" value={inventory.year} />}
            <DataListItem label="Type" value={inventory?.deviceType} />
            {inventory?.screenSize && <DataListItem label="Size" value={inventory.screenSize} />}
            {inventory?.color && <DataListItem label="Color" value={inventory.color} />}
            {inventory?.condition && <DataListItem label="Grade" value={inventory.condition} />}
          </>
        )}
        <DataListItem
          label="Location"
          value={<WarehouseLocationLink code={inventory?.warehouseLocation} locationId={inventory?.locationId} />}
        />
        {inventory.trackingNumber && <DataListItem label="Tracking #" value={inventory?.trackingNumber} />}
      </DataList>
      {children}
    </PicklistCard>
  );
}
